
export const environment = {
	production: false,
	app: {
		name: 'Ajin',
		version: '2023.03.20'
	},
	apiUrls: {
		ajin: 'https://api-worker.ukam.dev/v3/'
	},
	appUrls: {
		auth: 'http://localhost:1914',
		tools: 'http://localhost:1915',
		task: 'http://localhost:1916'
	},
};
